import GlobalData from "@/GlobalData";
import { api, client } from "@/client";
import { useAuthenticationStore } from "@/stores/authentication";
import { defineStore, acceptHMRUpdate } from "pinia";
import { useRouter } from "vue-router";
import { LogarithmicScale } from "chart.js";

export const useAudit = defineStore("audit", {
  state: () => ({
    activity_type: "Login" as string,
    id : 0 as number
  }),
  getters: {},
  actions: {
    async auditLog(activity_type:string){
      this.$reset();
      client.content
      .contentsAudit({
        activity:activity_type as api.ContentsAuditActivityEnum
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
      });

    }

  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAudit, import.meta.hot));
}
